import React, { useEffect, useState } from "react";
import { getUserName } from "../utils/authUtils";
import { useNavigate } from "react-router-dom";
import CombinedAIWidget from "./AIWidget";
// import CombinedAIWidget from "qurveaiwidget";
import { refresh_token, getUIConfig, getBaseUrl } from "../services/api";

const BASE_URL = getBaseUrl();

function Demo() {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [username, setUsername] = useState("");
  const [background_img_url, setBackground_img_url] = useState("");
  const [colorPalette, setColorPalette] = useState({});
  const [apiKey, setApiKey] = useState("");
  const [metadataObj, setMetadataObj] = useState(localStorage.getItem("metadata") ? JSON.parse(localStorage.getItem("metadata")) : {});

  // Function to transform the color palette format
  const transformColorPalette = (palette) => {
    if (!palette) return {};

    // If palette is a string, parse it to an object
    if (typeof palette === "string") {
      try {
        palette = JSON.parse(palette);
      } catch (error) {
        console.error("Error parsing palette:", error);
        return {};
      }
    }

    return {
      primary: palette.primary,
      secondary: palette.secondary,
      background: palette.background,
      aibackground: palette.aibackground,
      aiprimary: palette.aiprimary,
      text: palette.text,
      accent: palette.accent,
    };
  };

  // Transform metadata array [{key, value}, ...] to object {key: value, ...}
  const transformMetadata = (metadataArr) => {
    if (!Array.isArray(metadataArr)) return {};
    const obj = {};
    metadataArr.forEach((item) => {
      if (item.key) {
        obj[item.key] = item.value;
      }
    });
    return obj;
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userName = getUserName();
    if (!token || !userName) {
      navigate("/login");
      return;
    }
    setUsername(userName);

    async function loadConfig() {
      try {
        const result = await getUIConfig();
        setConfig(result);
        setApiKey(result.api_key);
        setColorPalette(transformColorPalette(result.colorPalette));
        setBackground_img_url(result.backgroundImgUrl);

        // Load metadata from localStorage, transform to object
        const savedMetadata = localStorage.getItem("metadata");
        if (savedMetadata) {
          const metadataArr = JSON.parse(savedMetadata);
          setMetadataObj(transformMetadata(metadataArr));
        } else {
          setMetadataObj({});
        }
      } catch (error) {
        console.error("Error loading config:", error);
        navigate("/login"); // Redirect to login on unexpected errors
      }
    }

    loadConfig();
  }, [navigate]);

  return (
    <div
      style={
        background_img_url
          ? {
              backgroundImage: `url(${background_img_url})`,
              width: "100vw",
              minHeight: "100vh",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }
          : {
              backgroundColor: "#f0f0f0",
              width: "100vw",
              minHeight: "100vh",
            }
      }
    >
      {colorPalette && Object.keys(colorPalette).length > 0 ? (
        <CombinedAIWidget
          apiKey={apiKey}
          BASE_URL={BASE_URL}
          username={username}
          onMessageSend={(message) => console.log("Message sent:", message)}
          onConversationReset={() => console.log("Conversation reset")}
          onCallStart={() => console.log("Call started")}
          onCallEnd={() => console.log("Call ended")}
          colorPalette={colorPalette}
          font="modern"
          metadata={metadataObj}
        />
      ) : (
        <div style={{ padding: "20px", textAlign: "center" }}>
          <p>
            To enable this page please connect Info@qurve.ai
          </p>
        </div>
      )}
    </div>
  );
}

export default Demo;
